'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window document Event */
var CoreComments = function (_PureComponent) {
    (0, _inherits3.default)(CoreComments, _PureComponent);

    function CoreComments() {
        (0, _classCallCheck3.default)(this, CoreComments);
        return (0, _possibleConstructorReturn3.default)(this, (CoreComments.__proto__ || (0, _getPrototypeOf2.default)(CoreComments)).apply(this, arguments));
    }

    (0, _createClass3.default)(CoreComments, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                async = _props.async,
                embedScript = _props.embedScript,
                publication = _props.publication,
                contentType = _props.contentType,
                contentId = _props.contentId,
                contentPublisher = _props.contentPublisher,
                lang = _props.lang,
                theme = _props.theme;

            // core-comments config: https://github.schibsted.io/bergens-tidende/comments-front#integration-on-article-pages

            window._ccConfig = { // eslint-disable-line no-underscore-dangle
                p: publication,
                contentType: contentType,
                contentId: contentId,
                contentPublisher: contentPublisher || publication,
                lang: lang,
                theme: theme
            };

            var script = document.createElement('script');
            script.setAttribute('data-content-id', contentId);
            script.id = 'core-comments';
            script.type = 'text/javascript';
            script.src = embedScript;
            script.async = async;

            this.instance.appendChild(script);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var iframe = this.instance.querySelector('iframe');
            if (iframe) {
                iframe.dispatchEvent(CoreComments.createCommentsDestroyEvent());
            }

            while (this.instance.firstChild) {
                this.instance.removeChild(this.instance.firstChild);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;


            return _react2.default.createElement('div', { className: theme.root, 'data-test-tag': '@spp/ui-core-comments', ref: function ref(el) {
                    _this2.instance = el;
                } });
        }
    }], [{
        key: 'createCommentsDestroyEvent',
        value: function createCommentsDestroyEvent() {
            var isIE = document.documentMode !== undefined;

            if (isIE) {
                var commentsDestroyEvent = document.createEvent('Event');
                commentsDestroyEvent.initEvent('comments-destroy', true, true);
                return commentsDestroyEvent;
            }

            return new Event('comments-destroy', {
                bubbles: true,
                cancelable: true
            });
        }
    }]);
    return CoreComments;
}(_react.PureComponent);

CoreComments.propTypes = {
    async: _propTypes2.default.bool,
    contentId: _propTypes2.default.string.isRequired,
    contentPublisher: _propTypes2.default.string,
    contentType: _propTypes2.default.string,
    embedScript: _propTypes2.default.string,
    lang: _propTypes2.default.string,
    publication: _propTypes2.default.string.isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string
    })
};
CoreComments.defaultProps = {
    async: true,
    contentPublisher: undefined,
    contentType: 'article',
    embedScript: '//comments-front-stage.herokuapp.com/assets/embedd.js',
    lang: 'en-us',
    theme: {}
};
exports.default = CoreComments;
//# sourceMappingURL=CoreComments.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-comments/lib/cjs/CoreComments.js
 ** module id = 594
 ** module chunks = 1
 **/